import React from 'react';
import styles from './PasswordStrengthBar.module.css';
import { countCriteriaMet, evaluatePassword } from '../utils/passwordCriteria';

interface PasswordStrengthBarProps {
  password: string;
}

type StrengthLevel = 'weak' | 'medium' | 'strong' | 'very-strong';

interface StrengthResult {
  level: StrengthLevel;
  label: string;
}

function getStrength(count: number): StrengthResult | null {
  if (count <= 0) {
    return null;
  }
  if (count === 1) {
    return { level: 'weak', label: 'Débil' };
  }
  if (count <= 3) {
    return { level: 'medium', label: 'Media' };
  }
  if (count === 4) {
    return { level: 'strong', label: 'Fuerte' };
  }
  return { level: 'very-strong', label: 'Muy fuerte' };
}

export default function PasswordStrengthBar({ password }: PasswordStrengthBarProps) {
  if (!password) {
    return null;
  }

  const count = countCriteriaMet(evaluatePassword(password));
  const strength = getStrength(count);

  if (!strength) {
    return null;
  }

  const widthPercent = (count / 5) * 100;

  return (
    <div className={styles.container}>
      <div className={styles.track}>
        <div
          className={`${styles.fill} ${styles[strength.level]}`}
          style={{ width: `${widthPercent}%` }}
        />
      </div>
      <span className={`${styles.label} ${styles[strength.level]}`}>{strength.label}</span>
    </div>
  );
}
